/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    VolumeMiniReference,
    VolumeMiniReferenceFromJSON,
    VolumeMiniReferenceFromJSONTyped,
    VolumeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootUpdate
 */
export interface MediaRootUpdate {
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootUpdate
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootUpdate
     */
    workflow?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {VolumeMiniReference}
     * @memberof MediaRootUpdate
     */
    volume: VolumeMiniReference;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    viewMode?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    viewStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    viewDefaultTab?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    prefetchThumbnailStrips?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    cover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    nameField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootUpdate
     */
    aiConfig?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootUpdate
     */
    shareComments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaRootUpdate
     */
    shareLinkDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRootUpdate
     */
    defaultProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootUpdate
     */
    cloudProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootUpdate
     */
    aiConnection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootUpdate
     */
    aiProxyProfile?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootUpdate
     */
    proxyProfiles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootUpdate
     */
    jobs?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootUpdate
     */
    tags?: Array<number>;
}

export function MediaRootUpdateFromJSON(json: any): MediaRootUpdate {
    return MediaRootUpdateFromJSONTyped(json, false);
}

export function MediaRootUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'workflow': !exists(json, 'workflow') ? undefined : json['workflow'],
        'volume': VolumeMiniReferenceFromJSON(json['volume']),
        'name': json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'viewMode': !exists(json, 'view_mode') ? undefined : json['view_mode'],
        'viewStyle': !exists(json, 'view_style') ? undefined : json['view_style'],
        'viewDefaultTab': !exists(json, 'view_default_tab') ? undefined : json['view_default_tab'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
        'cover': !exists(json, 'cover') ? undefined : json['cover'],
        'nameField': !exists(json, 'name_field') ? undefined : json['name_field'],
        'aiConfig': !exists(json, 'ai_config') ? undefined : json['ai_config'],
        'shareComments': !exists(json, 'share_comments') ? undefined : json['share_comments'],
        'shareLinkDuration': !exists(json, 'share_link_duration') ? undefined : json['share_link_duration'],
        'defaultProxyProfile': !exists(json, 'default_proxy_profile') ? undefined : json['default_proxy_profile'],
        'cloudProxyProfile': !exists(json, 'cloud_proxy_profile') ? undefined : json['cloud_proxy_profile'],
        'aiConnection': !exists(json, 'ai_connection') ? undefined : json['ai_connection'],
        'aiProxyProfile': !exists(json, 'ai_proxy_profile') ? undefined : json['ai_proxy_profile'],
        'proxyProfiles': !exists(json, 'proxy_profiles') ? undefined : json['proxy_profiles'],
        'jobs': !exists(json, 'jobs') ? undefined : json['jobs'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function MediaRootUpdateToJSON(value?: MediaRootUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'workflow': value.workflow,
        'volume': VolumeMiniReferenceToJSON(value.volume),
        'name': value.name,
        'path': value.path,
        'needs_rescan': value.needsRescan,
        'view_mode': value.viewMode,
        'view_style': value.viewStyle,
        'view_default_tab': value.viewDefaultTab,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'show_ai_metadata': value.showAiMetadata,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
        'cover': value.cover,
        'name_field': value.nameField,
        'ai_config': value.aiConfig,
        'share_comments': value.shareComments,
        'share_link_duration': value.shareLinkDuration,
        'default_proxy_profile': value.defaultProxyProfile,
        'cloud_proxy_profile': value.cloudProxyProfile,
        'ai_connection': value.aiConnection,
        'ai_proxy_profile': value.aiProxyProfile,
        'proxy_profiles': value.proxyProfiles,
        'jobs': value.jobs,
        'tags': value.tags,
    };
}


